import { useMemo } from 'react';

import { useAuth, useGlobal } from '@/hooks';
import { merge } from '@/utils';

import { Tracker } from '.';

const useAmplitude = () => {
  const global = useGlobal();
  return useMemo(() => global.amplitude(), [global.amplitude]);
};

export const useTracker = () => {
  const auth = useAuth();
  const tracker = useAmplitude();

  const dispatch: Tracker = (event, props = {}) => {
    if (!tracker.pageHandlersAdded) return;

    tracker.logEvent(event, props);
  };

  const dispatchWithUserData: Tracker = (event, props = {}) =>
    dispatch(event, merge({ user: { id: auth.user.id }, company: { id: auth.user.company.id } }, props));

  return { dispatch, dispatchWithUserData };
};
